import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { ReportCardModel } from '@smarttask-common/src/lib/models/Report/Card/Main/ReportCardModel';

export enum ReportCardActionTypes {
    ADD_REPORT_CARD = '[ReportCard] Create ReportCard',
    ADD_REPORT_CARDS = '[ReportCard] Add ReportCards',
    UPSERT_REPORT_CARD = '[ReportCard] Upsert ReportCard',
    UPSERT_REPORT_CARDS = '[ReportCard] Upsert ReportCards',
    UPDATE_REPORT_CARD = '[ReportCard] Update ReportCard',
    UPDATE_REPORT_CARDS = '[ReportCard] Update ReportCards',
    DELETE_REPORT_CARD = '[ReportCard] Delete ReportCard',
    DELETE_REPORT_CARDS = '[ReportCard] Delete ReportCards',
    DELETE_ALL_REPORT_CARDS = '[ReportCard] Delete All ReportCards',
    DELETE_ALL = '[ReportCard] Delete All',

    UPDATE_SELECTED_ID = '[ReportCard] Update SelectedId',
}

export class UpdateSelectedReportCardId implements Action {
    readonly type = ReportCardActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_card_id: string) {}
}

export class AddOne implements Action {
    readonly type = ReportCardActionTypes.ADD_REPORT_CARD;
    constructor(public card: ReportCardModel) {}
}

export class AddMany implements Action {
    readonly type = ReportCardActionTypes.ADD_REPORT_CARDS;
    constructor(public cards: Array<ReportCardModel>) {}
}

export class UpsertOne implements Action {
    readonly type = ReportCardActionTypes.UPSERT_REPORT_CARD;

    constructor(public card: ReportCardModel) {}
}

export class UpsertMany implements Action {
    readonly type = ReportCardActionTypes.UPSERT_REPORT_CARDS;
    constructor(public cards: Array<ReportCardModel>) {}
}

export class UpdateOne implements Action {
    readonly type = ReportCardActionTypes.UPDATE_REPORT_CARD;
    constructor(public card: Update<ReportCardModel>) {}
}

export class UpdateMany implements Action {
    readonly type = ReportCardActionTypes.UPDATE_REPORT_CARDS;
    constructor(public cards: Array<Update<ReportCardModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = ReportCardActionTypes.DELETE_REPORT_CARD;
    constructor(public id: string) {}
}

export class DeleteMany implements Action {
    readonly type = ReportCardActionTypes.DELETE_REPORT_CARDS;
    constructor(public ids: Array<string>) {}
}

export class DeleteAll implements Action {
    readonly type = ReportCardActionTypes.DELETE_ALL_REPORT_CARDS;
    constructor(public ids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = ReportCardActionTypes.DELETE_ALL;
    constructor() {}
}

export type ReportCardActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedReportCardId;
